'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Util


// Custom Decorators


// Actions


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _lodash = require('lodash');

var _recompose = require('recompose');

var _elementRegistry = require('../../common/elements/elementRegistry');

var elementRegistry = _interopRequireWildcard(_elementRegistry);

var _domUtil = require('../utils/domUtil');

var _gridUtils = require('../utils/grid/gridUtils');

var _selectionUtils = require('./selection/selectionUtils');

var _elementHelper = require('../../common/elements/elementHelper');

var _elementSelector = require('./elementSelector');

var _elementSelector2 = _interopRequireDefault(_elementSelector);

var _propsComparisons = require('../utils/react/propsComparisons');

var _elementResizeDecorator = require('./resizing/elementResizeDecorator');

var _elementResizeDecorator2 = _interopRequireDefault(_elementResizeDecorator);

var _measureElementDecorator = require('../components/measurements/measureElementDecorator');

var _measureElementDecorator2 = _interopRequireDefault(_measureElementDecorator);

var _DraggableElement = require('./dnd/DraggableElement');

var _DraggableElement2 = _interopRequireDefault(_DraggableElement);

var _selectionActions = require('./selection/selectionActions');

var _elementActions = require('./elementActions');

var _dragModifierKeysConstants = require('../utils/dnd/modifierKeys/dragModifierKeysConstants');

require('./Element.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNoLongerResizing = (0, _propsComparisons.noLonger)('isResizing');

var shouldAttachDragSource = function shouldAttachDragSource(_ref) {
    var isEditable = _ref.isEditable,
        isEditing = _ref.isEditing,
        isEditingChild = _ref.isEditingChild,
        documentMode = _ref.documentMode;
    return isEditable && !isEditing && !isEditingChild && !documentMode;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchUpdateElement: function dispatchUpdateElement(_ref2) {
            var id = _ref2.id,
                changes = _ref2.changes,
                sync = _ref2.sync,
                analyticsEvent = _ref2.analyticsEvent,
                transactionId = _ref2.transactionId;
            return dispatch((0, _elementActions.updateElement)({ id: id, changes: changes, sync: sync, analyticsEvent: analyticsEvent, transactionId: transactionId }));
        },
        dispatchSetSelectedElements: function dispatchSetSelectedElements(ids) {
            return dispatch((0, _selectionActions.setSelectedElements)({ ids: ids }));
        },
        dispatchToggleSelectedElements: function dispatchToggleSelectedElements(ids) {
            return dispatch((0, _selectionActions.toggleSelectedElements)({ ids: ids }));
        },
        dispatchStartEditingElement: function dispatchStartEditingElement(id, editorKey) {
            return dispatch((0, _selectionActions.startEditingElement)({ id: id, editorKey: editorKey }));
        },
        stopEditing: function stopEditing() {
            return dispatch((0, _selectionActions.finishEditingElement)());
        }
    };
};

var ElementContainer = (_dec = (0, _reactRedux.connect)(_elementSelector2.default, mapDispatchToProps), _dec(_class = (0, _DraggableElement2.default)(_class = (0, _measureElementDecorator2.default)(_class = (0, _elementResizeDecorator2.default)(_class = (0, _recompose.pure)(_class = function (_React$Component) {
    _inherits(ElementContainer, _React$Component);

    function ElementContainer(props) {
        _classCallCheck(this, ElementContainer);

        var _this = _possibleConstructorReturn(this, (ElementContainer.__proto__ || Object.getPrototypeOf(ElementContainer)).call(this, props));

        _this.onMouseDown = function (event) {
            var _this$props = _this.props,
                isRemotelySelected = _this$props.isRemotelySelected,
                isLocked = _this$props.isLocked,
                stopEditing = _this$props.stopEditing,
                documentMode = _this$props.documentMode,
                isEditing = _this$props.isEditing;

            if (documentMode) return;

            event.stopPropagation();
            if (isLocked) _this.selectThisElement(event);

            if (!isRemotelySelected && isEditing) stopEditing();
        };

        _this.onClick = function (event) {
            var isLocked = _this.props.isLocked;

            // The locked selection is already handled by the onMouseDown

            if (isLocked) return;

            // Clicks will be prevented during a resize as we don't want to select the element after resizing
            if (_this.preventClick) return;

            _this.selectThisElement(event);
        };

        _this.startEditing = function (editorKey) {
            var _this$props2 = _this.props,
                element = _this$props2.element,
                isEditable = _this$props2.isEditable,
                isRemotelyActive = _this$props2.isRemotelyActive,
                dispatchStartEditingElement = _this$props2.dispatchStartEditingElement;


            if (!isEditable || isRemotelyActive) return;

            dispatchStartEditingElement(element.get('id'), editorKey);
        };

        _this.selectThisElement = function (event) {
            var _this$props3 = _this.props,
                isEditable = _this$props3.isEditable,
                isRemotelyActive = _this$props3.isRemotelyActive,
                element = _this$props3.element,
                dispatchSetSelectedElements = _this$props3.dispatchSetSelectedElements,
                dispatchToggleSelectedElements = _this$props3.dispatchToggleSelectedElements;


            if (!isEditable && !(0, _elementHelper.isBoard)(element)) {
                return;
            }
            event && event.stopPropagation();

            if (isRemotelyActive) return;

            var selectIds = [element.get('id')];
            if ((0, _elementHelper.isAlias)(element)) selectIds.push(element.getIn(['content', 'linkTo']));

            return (0, _selectionUtils.isAttemptingMultiSelect)(event) ? dispatchToggleSelectedElements(selectIds) : dispatchSetSelectedElements(selectIds);
        };

        _this.elementEvents = {
            onMouseDown: _this.onMouseDown,
            onClick: _this.onClick,
            onDoubleClick: _domUtil.stopPropagationOnly
        };


        _this.preventClick = false;
        return _this;
    }

    _createClass(ElementContainer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var connectDragPreview = this.props.connectDragPreview;

            if (connectDragPreview) {
                connectDragPreview((0, _reactDndHtml5Backend.getEmptyImage)());
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.isSelected) {
                var domNode = _reactDom2.default.findDOMNode(this);
                if (!(0, _domUtil.isDOMNodeInView)(domNode)) domNode.scrollIntoView();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            // If the element is selected and the modified time is within 300ms then scroll it into view.
            if (!this.props.isSelected && nextProps.isSelected && this.props.element.getIn(['meta', 'modifiedTime']) > new Date().getTime() - 300) {
                var domNode = _reactDom2.default.findDOMNode(this);
                if (!(0, _domUtil.isDOMNodeInView)(domNode)) domNode.scrollIntoView();
            }

            // Prevent a click which occurs immediately after a resize from selecting the element
            if (isNoLongerResizing(this.props, nextProps)) {
                this.preventClick = true;
                (0, _lodash.defer)(function () {
                    _this2.preventClick = false;
                });
            }
        }

        /**
         * If the element receives the mouse down event (because an input hasn't stopped propagation of the mouse down
         * event).
         */

    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                element = _props.element,
                isDragging = _props.isDragging,
                connectDragSource = _props.connectDragSource,
                dragModifierKeys = _props.dragModifierKeys,
                isResizing = _props.isResizing;


            var DisplayElement = elementRegistry.getElementContainerComponent(element.get('elementType'));
            if (!DisplayElement) return null;

            var normalisedFontStyle = (0, _gridUtils.getNormalisedFontStyle)(this.props);

            var copyDrag = dragModifierKeys.get(_dragModifierKeysConstants.MODIFIER_KEYS.altKey);
            var dropEffect = copyDrag ? 'copy' : 'move';

            var elementClasses = (0, _classnames2.default)('Element', {
                dragging: isDragging && !copyDrag,
                copy: isDragging && copyDrag,
                resizing: isResizing
            });

            var elementRender = _react2.default.createElement(
                'div',
                { className: elementClasses,
                    'data-element-id': element.get('id'),
                    style: normalisedFontStyle },
                _react2.default.createElement(DisplayElement, _extends({
                    startEditing: this.startEditing,
                    elementEvents: this.elementEvents
                }, this.props))
            );

            var wrappingFn = shouldAttachDragSource(this.props) ? connectDragSource : _lodash.identity;
            return wrappingFn(elementRender, { dropEffect: dropEffect });
        }
    }]);

    return ElementContainer;
}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);
exports.default = ElementContainer;


ElementContainer.propTypes = {
    element: _propTypes2.default.object.isRequired,
    currentBoardId: _propTypes2.default.string.isRequired,
    isRemotelyActive: _propTypes2.default.bool,
    isEditing: _propTypes2.default.bool,
    isEditingChild: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool,
    isDraggable: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    isLocked: _propTypes2.default.bool,
    isOver: _propTypes2.default.bool,
    inList: _propTypes2.default.string,
    isDragging: _propTypes2.default.bool,
    isResizing: _propTypes2.default.bool,
    isHovered: _propTypes2.default.bool,
    canDrop: _propTypes2.default.bool,
    isRemotelySelected: _propTypes2.default.bool,
    remoteSelectionData: _propTypes2.default.object,
    connectDropTarget: _propTypes2.default.func,
    connectDragSource: _propTypes2.default.func,
    connectDragPreview: _propTypes2.default.func,
    dispatchSetSelectedElements: _propTypes2.default.func,
    dispatchToggleSelectedElements: _propTypes2.default.func,
    dispatchStartEditingElement: _propTypes2.default.func,
    dispatchUpdateElement: _propTypes2.default.func,
    stopEditing: _propTypes2.default.func,
    documentMode: _propTypes2.default.bool,
    dragModifierKeys: _propTypes2.default.object,
    dispatchGetSelectedElementIds: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/ElementContainer.js
// module id = 1946
// module chunks = 0